module.exports = __webpack_public_path__ + "img/410.e12cf31b.jpg";